// extracted by mini-css-extract-plugin
module.exports = {"articleLayout":"dette-trenger-du_articleLayout__wYIGm","section":"dette-trenger-du_section__g5_bV"};